import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import moment from 'moment'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ReactTooltip from 'react-tooltip';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import AutosuggestComponent from '../../../Utility/Components/AutosuggestComponent';
import CustomNoRowsOverlay from '../../../Utility/Components/CustomNoRowsOverlay';
import CommonDateTimePicker from '../../../Utility/Components/CommonDateTimePicker';
import ErrorBoundary from '../../../Utility/Components/ErrorBoundary';
import ModalGlobal from '../../../Utility/Components/ModalGlobal';
import Utility from '../../../Utility/Utility';
import { logsDetails, logsDetailsFilter, getLogDetailsById } from '../Controller/LogsController';
import RefreshButton from '../../../Utility/Components/RefreshButton'
import '../Assets/css/logsDoc.scss';

function Logs(props) {
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: 'Entity Type',
                field: "entity_type",
                minWidth: 110,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('entity_type') && params.data.entity_type != null && params.data.entity_type != "") {
                            if (params.data.entity_type.length >= 18) {
                                return <div className="usercursor">
                                    <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">{params.data.entity_type}</Tooltip>}>
                                        <span >{(params.data.entity_type).substring(0, 15) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.entity_type}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Entity Name',
                field: "entity_name",
                minWidth: 140,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('entity_name') && params.data.entity_name != null && params.data.entity_name != "") {
                            if (params.data.entity_name.length >= 20) {
                                return <div className="usercursor">
                                    <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">{params.data.entity_name}</Tooltip>}>
                                        <span >{(params.data.entity_name).substring(0, 17) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.entity_name}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Job Type',
                field: "job_type",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('job_type') && params.data.job_type != null && params.data.job_type != "") {
                            if (params.data.job_type.length >= 21) {
                                return <div className="usercursor">
                                    <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">{params.data.job_type}</Tooltip>}>
                                        <span >{(params.data.job_type).substring(0, 18) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.job_type}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Applied Date',
                field: "applied_date",
                minWidth: 190,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('applied_date') && params.data.applied_date != null && params.data.applied_date != "") {
                            if (params.data.applied_date.length >= 30) {
                                return <div className="usercursor">
                                    <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">{params.data.applied_date}</Tooltip>}>
                                        <span >{(params.data.applied_date).substring(0, 27) + "..."}</span>
                                    </OverlayTrigger>
                                </div>
                            } else {
                                return <div className="detailsViewContentInner">
                                    <div className="detailsViewContent">
                                        <span className='textrenderview'>
                                            {params.data.applied_date}
                                        </span>
                                    </div>
                                </div>
                            }
                        } else {
                            return <span>-</span>;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Requested At',
                field: "requested_at",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('requested_at') && params.data.requested_at != null && params.data.requested_at != "") {
                            return <div>{params.data.requested_at}</div>
                        } else {
                            return <span>-</span>;
                        }
                    } else {
                        return null;
                    }
                }
            },
            {
                headerName: 'Updated At',
                field: "updated_at",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('updated_at') && params.data.updated_at != null && params.data.updated_at != "Invalid date" && params.data.updated_at != "") {
                            return <div>{params.data.updated_at}</div>
                        } else {
                            return <span>-</span>;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Status',
                field: "status",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,

                cellRenderer: (params) => {
                    if (params.data && params.data.status) {
                        const status = params.data.status.toLowerCase();
                        let icon = "⏺️";
                        let colorClass = "";
                        switch (status) {
                            case "completed":
                                icon = "✅";
                                colorClass = "status-completed";
                                break;
                            case "failed":
                                icon = "⚠️";
                                colorClass = "status-failed";
                                break;
                            case "pending":
                                icon = "⏳";
                                colorClass = "status-pending";
                                break;
                            case "in progress":
                                icon = "🕓";
                                colorClass = "status-inprogress";
                                break;
                            default:
                                icon = "ℹ️";
                                colorClass = "status-default";
                                break;
                        }

                        return (
                            <div className="status-badge-inner">
                                <div className={`status-badge ${colorClass}`}>
                                    <span className="status-icon">{icon}</span>
                                    <span className="status-text">{params.data.status}</span>
                                </div>
                            </div>
                        );
                    } else {
                        return <span>-</span>;
                    }
                },
            },
            {
                headerName: 'Error Log',
                field: "error_log",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('error_log') && params.data.error_log != null && params.data.error_log != "") {
                            if (params.data.error_log.length >= 20) {
                                return <div className="error-logs-box">
                                    <div className='error-log-inner'>
                                        <span >{(params.data.error_log).substring(0, 17) + "..."}</span>
                                        <span className="error-logs-icon" onClick={() => { errorLogModal(params.data.error_log) }}>
                                            <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{"Click to view error log"}</Tooltip>}>
                                                <i className="fa fa-info-circle"></i>
                                            </OverlayTrigger>
                                        </span>
                                    </div>
                                </div>
                            } else {
                                return <div className="error-logs-box">{params.data.error_log}</div>
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Actions',
                field: "actions",
                minWidth: 100,
                maxWidth: 100,
                sortable: false,
                suppressMovable: true,
                // pinned: 'right',
                cellRenderer: (params) => {
                    if (params.data) {
                        return (
                            <div className="action-icons">
                                <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>View Details</Tooltip>}>
                                    <i 
                                        className="fa fa-eye" 
                                        style={{ cursor: 'pointer', fontSize: '16px', color: '#525252' }}
                                        onClick={() => handleViewDetails(params.data)}
                                    ></i>
                                </OverlayTrigger>
                            </div>
                        );
                    }
                    return null;
                },
            },
        ]
    )

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const gridRef = useRef();
    const [logsReportData, setLogsReportData] = useState([]);
    const [statusFilterSelectedValue, setStatusFilterSelectedValue] = useState("");
    const [statusFilterList, setStatusFilterList] = useState([]);
    const [entityTypeFilterSelectedValue, setEntityTypeFilterSelectedValue] = useState("");
    const [entityTypeFilterList, setEntityTypeFilterList] = useState([]);
    const [jobTypeFilterSelectedValue, setJobTypeFilterSelectedValue] = useState("");
    const [jobTypeFilterList, setJobTypeFilterList] = useState([]);
    const [logsStartDate, setLogsStartDate] = useState(null);
    const [logsEndDate, setLogsEndDate] = useState(null);
    const [errorLogModalShow, setErrorLogModalShow] = useState(false);
    const [errorLogModalData, setErrorLogModalData] = useState(null);
    const [detailsModalShow, setDetailsModalShow] = useState(false);
    const [detailsModalData, setDetailsModalData] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [isAnimating, setIsAnimating] = useState(true);
    const logFilterRef = useRef(true);

    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    const resetDataGrid = (e = null) => {
        var datasource = serverSideDataSource(e)
        gridApi.setDatasource(datasource);
    }

    //Logs history aggrid server side api fn
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse, selectedUserId } = props;
                loaderStateTrue();

                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);

                if (entityTypeFilterSelectedValue && entityTypeFilterSelectedValue != "") {
                    globalQueryParamshash['job_type'] = entityTypeFilterSelectedValue.value
                }
                if (jobTypeFilterSelectedValue && jobTypeFilterSelectedValue != "") {
                    globalQueryParamshash['action'] = jobTypeFilterSelectedValue.value
                }
                if (statusFilterSelectedValue && statusFilterSelectedValue != "") {
                    globalQueryParamshash['status'] = statusFilterSelectedValue.value
                }

                if (logsStartDate && logsStartDate != "" && logsEndDate && logsEndDate != "") {
                    let from_date = moment(new Date(logsStartDate)).format('YYYY-MM-DD')
                    let to_date = moment(new Date(logsEndDate)).format('YYYY-MM-DD')
                    globalQueryParamshash['date_range'] = [from_date, to_date];
                }

                filters['filters'] = JSON.stringify(globalQueryParamshash)
                let filterServerside = Object.keys(JSON.parse(filters.filters)).length > 0 ? filters : null

                logsDetails(filterServerside).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                    } else {
                        console.error(error);
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                }).catch((error) => {
                    console.error("************error*************", error)
                    loaderStateFalse();
                    setIsAnimating(false);
                });
            }
        };
    }

    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )


    //get branch list initially for branch filter 
    useEffect(() => {
        if (logFilterRef.current) {
            logFilterRef.current = false;
            logsDetailsFilterApi();
        }
    }, [])

    const logsDetailsFilterApi = () => {
        const { loaderStateTrue, loaderStateFalse, } = props;
        loaderStateTrue();
        logsDetailsFilter().then((response) => {
            if (response.success) {
                if (Object.keys(response.data).length > 0) {
                    setLogsReportData(response.data);
                } else {
                    setLogsReportData([]);
                }
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    };

    //Entity Type selection dropdown changes useeffect
    useEffect(() => {
        if (gridApi && entityTypeFilterSelectedValue != "" && entityTypeFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && entityTypeFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [entityTypeFilterSelectedValue])

    //Job Type selection dropdown changes useeffect
    useEffect(() => {
        if (gridApi && jobTypeFilterSelectedValue != "" && jobTypeFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && jobTypeFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [jobTypeFilterSelectedValue])

    //Status selection dropdown changes useeffect
    useEffect(() => {
        if (gridApi && statusFilterSelectedValue != "" && statusFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && statusFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [statusFilterSelectedValue])

    //when logs date range change , logs list reset
    useEffect(() => {
        if (gridApi && logsStartDate && logsStartDate != "" && logsEndDate && logsEndDate != "") {
            resetDataGrid();
        }
        else if (gridApi && logsStartDate == null && logsEndDate == null) {
            resetDataGrid();
        }
    }, [logsEndDate])

    // Populate filter lists from logsReportData
    useEffect(() => {
        if (logsReportData && typeof logsReportData === 'object') {

            // Helper function to format labels
            const formatLabel = (text) => {
                return text.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            };

            // Set job type filter list
            if (logsReportData.job_type && Array.isArray(logsReportData.job_type)) {
                const jobTypeOptions = logsReportData.job_type.map(jobType => ({
                    label: formatLabel(jobType),
                    value: jobType
                }));
                setEntityTypeFilterList(jobTypeOptions);

            }

            // Set action filter list (assuming you have setActionFilterList)
            if (logsReportData.action && Array.isArray(logsReportData.action)) {
                const actionOptions = logsReportData.action.map(action => ({
                    label: formatLabel(action),
                    value: action
                }));
                setJobTypeFilterList(actionOptions);
            }

            // Set status filter list
            if (logsReportData.status && Array.isArray(logsReportData.status)) {
                const statusOptions = logsReportData.status.map(status => ({
                    label: formatLabel(status),
                    value: status
                }));
                setStatusFilterList(statusOptions);
            }

        }
    }, [logsReportData])

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    const handleChangeLogsFilter = (type, event) => {
        if (type == 'entity_type') {
            if (event) {
                setEntityTypeFilterSelectedValue(event)
            } else {
                setEntityTypeFilterSelectedValue("")
            }
        }

        if (type == 'job_type') {
            if (event) {
                setJobTypeFilterSelectedValue(event)
            } else {
                setJobTypeFilterSelectedValue("")
            }
        }
        if (type == 'status') {
            if (event) {
                setStatusFilterSelectedValue(event)
            } else {
                setStatusFilterSelectedValue("")
            }
        }
    }

    //Date range filteration onchange fn
    const onChangeDateRange = (dates) => {
        const [start, end] = dates;
        setLogsStartDate(start);
        setLogsEndDate(end);
    };

    //Logs csv download fn
    const logsCsvDownload = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};
        if (entityTypeFilterSelectedValue && entityTypeFilterSelectedValue != "") {
            globalQueryParamshash['job_type'] = entityTypeFilterSelectedValue.value
        }
        if (jobTypeFilterSelectedValue && jobTypeFilterSelectedValue != "") {
            globalQueryParamshash['action'] = jobTypeFilterSelectedValue.value
        }
        if (statusFilterSelectedValue && statusFilterSelectedValue != "") {
            globalQueryParamshash['status'] = statusFilterSelectedValue.value
        }

        if (logsStartDate && logsStartDate != "" && logsEndDate && logsEndDate != "") {
            let from_date = moment(new Date(logsStartDate)).format('YYYY-MM-DD')
            let to_date = moment(new Date(logsEndDate)).format('YYYY-MM-DD')
            globalQueryParamshash['date_range'] = [from_date, to_date];
        }

        globalQueryParamshash['download'] = 'csv';

        filters['filters'] = JSON.stringify(globalQueryParamshash)
        let filterServerside = Object.keys(JSON.parse(filters.filters)).length > 0 ? filters : null
        loaderStateTrue();
        logsDetails(filterServerside).then((response) => {
            if (response.hasOwnProperty('success') && !response.success) {
                Utility.toastNotifications(response.message, 'Warning', 'warning')
            } else {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `logs_${moment().format("DD_MM_YYYY_hh_mm")}.csv`);
                link.click();
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    const errorLogModal = (errorLog) => {
        setErrorLogModalData(errorLog)
        setErrorLogModalShow(true)
    }

    const errorLogModalClose = () => {
        setErrorLogModalData(null)
        setErrorLogModalShow(false)
    }

    const handleViewDetails = (rowData) => {
        if (rowData && rowData.job_id) {
            setLoadingDetails(true);
            setDetailsModalShow(true);
            const { loaderStateTrue, loaderStateFalse } = props;
            loaderStateTrue();
            
            getLogDetailsById(rowData.job_id)
                .then((response) => {
                    if (response && response.success && response.data && response.data.length > 0) {
                        const jobData = response.data[0];
                        if (jobData.CMJob_data && jobData.CMJob_data.length > 0) {
                            setDetailsModalData(jobData.CMJob_data[0]);
                        } else {
                            setDetailsModalData(null);
                            Utility.toastNotifications("No details found", "Warning", "warning");
                        }
                    } else {
                        setDetailsModalData(null);
                        Utility.toastNotifications("Failed to fetch details", "Error", "error");
                    }
                    setLoadingDetails(false);
                    loaderStateFalse();
                })
                .catch((error) => {
                    console.error("Error fetching log details:", error);
                    setDetailsModalData(null);
                    setLoadingDetails(false);
                    loaderStateFalse();
                    Utility.toastNotifications("Error fetching log details", "Error", "error");
                });
        }
    }

    const detailsModalClose = () => {
        setDetailsModalData(null)
        setDetailsModalShow(false)
    }

    const copyToClipboard = (value, event) => {
        if (!value) return;
        
        // Store button reference before async operation
        const btn = event.currentTarget;
        if (!btn) return;
        
        const originalHTML = btn.innerHTML;
        
        navigator.clipboard.writeText(String(value))
            .then(() => {
                btn.innerHTML = "<i class='fa fa-check'></i>";
                btn.classList.add('btn-success');
                btn.classList.remove('btn-outline-secondary');
                setTimeout(() => {
                    btn.innerHTML = originalHTML;
                    btn.classList.remove('btn-success');
                    btn.classList.add('btn-outline-secondary');
                }, 1200);
            })
            .catch(err => {
                console.error("Copy failed:", err);
                Utility.toastNotifications("Failed to copy", "Error", "error");
            });
    }

    const renderDetailsContent = () => {
        if (loadingDetails) {
            return (
                <div className="d-flex justify-content-center align-items-center py-5">
                    <div className="spinner-border mr-2" role="status" />
                    <span>Loading details...</span>
                </div>
            );
        }

        if (!detailsModalData) {
            return (
                <div className="alert alert-info mb-0">
                    No details available for this job.
                </div>
            );
        }

        const data = detailsModalData;

        const formatDate = value =>
            value ? moment(value).format('DD-MM-YYYY HH:mm:ss') : '-';

        const getStatusVariant = status => {
            if (!status) return 'secondary';
            const s = status.toLowerCase();
            if (s === 'completed' || s === 'success') return 'success';
            if (s === 'failed' || s === 'error') return 'danger';
            if (s === 'in_progress' || s === 'processing' || s === 'running') return 'warning';
            return 'secondary';
        };

        let parsedPayload = null;
        try {
            if (data.payload && typeof data.payload === 'string') {
                parsedPayload = JSON.parse(data.payload);
            } else if (Array.isArray(data.payload)) {
                parsedPayload = data.payload;
            }
        } catch (e) {
            console.error('Failed to parse payload:', e);
        }

        let cmResponseToShow = data.cm_response;
        try {
            if (typeof data.cm_response === 'string' && data.cm_response.trim()) {
                cmResponseToShow = JSON.parse(data.cm_response);
            }
        } catch (e) {
            // fall back to raw string
        }

        let originalPayloadToShow = data.original_payload_sent;
        try {
            if (typeof data.original_payload_sent === 'string' && data.original_payload_sent.trim()) {
                originalPayloadToShow = JSON.parse(data.original_payload_sent);
            }
        } catch (e) {
            // fall back to raw string
        }

        return (
            <div className="log-details-content">
                <div className="container-fluid p-0">
                    {/* Header summary */}
                    <div className="row align-items-center mb-3">
                        <div className="col-md-8">
                            <h5 className="mb-1 d-flex align-items-center">
                                Job{' '}
                                <span className="text-monospace mx-2">
                                    {data.job_id || '-'}
                                </span>
                                {data.job_id && (
                                    <button
                                        className="btn btn-sm btn-outline-secondary copy-btn"
                                        onClick={(e) => copyToClipboard(data.job_id, e)}
                                        title="Copy Job ID"
                                    >
                                        <i className="fa fa-copy"></i>
                                    </button>
                                )}
                            </h5>
                            <small className="text-muted">
                                <strong>Type:</strong> {data.job_type || '-'} · <strong>Action:</strong>{' '}
                                {data.action || '-'} · <strong>Org:</strong>{' '}
                                {data.org_id || '-'}
                            </small>
                        </div>
                        <div className="col-md-4 text-md-right mt-3 mt-md-0">
                            <span
                                className={`badge badge-pill badge-${getStatusVariant(
                                    data.status
                                )} mr-2`}
                            >
                                {data.status || 'Unknown'}
                            </span>
                            {data.cm_name && (
                                <span className="badge badge-pill badge-info mr-2">
                                    CM: {data.cm_name}
                                </span>
                            )}
                            <span className="badge badge-light">
                                Retries: {data.retries || 0}
                            </span>
                        </div>
                    </div>

                    {/* Job Info + Timestamps */}
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                    <span className="font-weight-semibold">
                                        Job Information
                                    </span>
                                    {typeof data.priority === 'number' && (
                                        <span className="badge badge-secondary">
                                            Priority: {data.priority}
                                        </span>
                                    )}
                                </div>
                                <div className="card-body py-3">
                                    <dl className="row mb-0">
                                        <dt className="col-5 col-sm-4 text-muted">
                                            Job ID
                                        </dt>
                                        <dd className="col-7 col-sm-8 d-flex align-items-center">
                                            <span className="text-monospace mr-2">{data.job_id || '-'}</span>
                                            {data.job_id && (
                                                <button
                                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                                    onClick={(e) => copyToClipboard(data.job_id, e)}
                                                    title="Copy Job ID"
                                                >
                                                    <i className="fa fa-copy"></i>
                                                </button>
                                            )}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Organization ID
                                        </dt>
                                        <dd className="col-7 col-sm-8 d-flex align-items-center">
                                            <span className="mr-2">{data.org_id || '-'}</span>
                                            {data.org_id && (
                                                <button
                                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                                    onClick={(e) => copyToClipboard(data.org_id, e)}
                                                    title="Copy Organization ID"
                                                >
                                                    <i className="fa fa-copy"></i>
                                                </button>
                                            )}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Job Type
                                        </dt>
                                        <dd className="col-7 col-sm-8 d-flex align-items-center">
                                            <span className="mr-2">{data.job_type || '-'}</span>
                                            {data.job_type && (
                                                <button
                                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                                    onClick={(e) => copyToClipboard(data.job_type, e)}
                                                    title="Copy Job Type"
                                                >
                                                    <i className="fa fa-copy"></i>
                                                </button>
                                            )}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Action
                                        </dt>
                                        <dd className="col-7 col-sm-8 d-flex align-items-center">
                                            <span className="mr-2">{data.action || '-'}</span>
                                            {data.action && (
                                                <button
                                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                                    onClick={(e) => copyToClipboard(data.action, e)}
                                                    title="Copy Action"
                                                >
                                                    <i className="fa fa-copy"></i>
                                                </button>
                                            )}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            CM Name
                                        </dt>
                                        <dd className="col-7 col-sm-8 d-flex align-items-center">
                                            <span className="mr-2">{data.cm_name || '-'}</span>
                                            {data.cm_name && (
                                                <button
                                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                                    onClick={(e) => copyToClipboard(data.cm_name, e)}
                                                    title="Copy CM Name"
                                                >
                                                    <i className="fa fa-copy"></i>
                                                </button>
                                            )}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Created By
                                        </dt>
                                        <dd className="col-7 col-sm-8">
                                            {data.created_by || '-'}
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <div className="card shadow-sm h-100">
                                <div className="card-header py-2">
                                    <span className="font-weight-semibold">
                                        Timestamps
                                    </span>
                                </div>
                                <div className="card-body py-3">
                                    <dl className="row mb-0">
                                        <dt className="col-5 col-sm-4 text-muted">
                                            Created At
                                        </dt>
                                        <dd className="col-7 col-sm-8">
                                            {formatDate(data.createdAt)}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Updated At
                                        </dt>
                                        <dd className="col-7 col-sm-8">
                                            {formatDate(data.updatedAt)}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Started At
                                        </dt>
                                        <dd className="col-7 col-sm-8">
                                            {formatDate(data.started_at)}
                                        </dd>

                                        <dt className="col-5 col-sm-4 text-muted">
                                            Completed At
                                        </dt>
                                        <dd className="col-7 col-sm-8">
                                            {formatDate(data.completed_at)}
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Payload */}
                    {parsedPayload && Array.isArray(parsedPayload) && parsedPayload.length > 0 && (
                        <div className="card shadow-sm mb-3">
                            <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                <span className="font-weight-semibold">Payload Details</span>
                                <div>
                                    <span className="badge badge-light mr-2">
                                        {parsedPayload.length} item{parsedPayload.length > 1 ? 's' : ''}
                                    </span>
                                    <button
                                        className="btn btn-sm btn-outline-secondary copy-btn"
                                        onClick={(e) => copyToClipboard(JSON.stringify(parsedPayload, null, 2), e)}
                                        title="Copy entire payload"
                                    >
                                        <i className="fa fa-copy"></i> Copy All
                                    </button>
                                </div>
                            </div>

                            <div className="card-body payload-scroll">
                                {parsedPayload.map((item, index) => (
                                    <div key={index} className="mb-3">
                                        {/* <div className="font-weight-semibold mb-1">Item {index + 1}</div> */}
                                        <pre className="small text-monospace payload-json-pre">
                                            {JSON.stringify(item, null, 2)}
                                        </pre>
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Error */}
                    {data.error_message && data.error_message.trim() !== '' && (
                        <div className="alert alert-danger mb-3">
                            <h6 className="alert-heading mb-2">Error Message</h6>
                            <pre className="mb-0 small text-monospace">
                                {data.error_message}
                            </pre>
                        </div>
                    )}

                    {/* CM Response */}
                    {data.cm_response && data.cm_response !== '' && (
                        <div className="card shadow-sm mb-3">
                            <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                <span className="font-weight-semibold">
                                    CM Response
                                </span>
                                <button
                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                    onClick={(e) => copyToClipboard(typeof cmResponseToShow === 'string' ? cmResponseToShow : JSON.stringify(cmResponseToShow, null, 2), e)}
                                    title="Copy CM Response"
                                >
                                    <i className="fa fa-copy"></i> Copy
                                </button>
                            </div>
                            <div className="card-body">
                                <pre className="mb-0 small text-monospace cm-response-pre">
                                    {typeof cmResponseToShow === 'string'
                                        ? cmResponseToShow
                                        : JSON.stringify(cmResponseToShow, null, 2)}
                                </pre>
                            </div>
                        </div>
                    )}

                    {/* Original Payload */}
                    {data.original_payload_sent && (
                        <div className="card shadow-sm">
                            <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                <span className="font-weight-semibold">
                                    Original Payload Sent
                                </span>
                                <button
                                    className="btn btn-sm btn-outline-secondary copy-btn"
                                    onClick={(e) => copyToClipboard(typeof originalPayloadToShow === 'string' ? originalPayloadToShow : JSON.stringify(originalPayloadToShow, null, 2), e)}
                                    title="Copy Original Payload"
                                >
                                    <i className="fa fa-copy"></i> Copy
                                </button>
                            </div>
                            <div className="card-body">
                                <pre className="mb-0 small text-monospace original-payload-pre">
                                    {typeof originalPayloadToShow === 'string'
                                        ? originalPayloadToShow
                                        : JSON.stringify(originalPayloadToShow, null, 2)}
                                </pre>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    //Logs grid refresh button click fn
    const loadGrid = () => {
        resetDataGrid();
    }

    return (
        <div className="gridcontainer">
            <div className='filterSection'>
                <div className="gridtopviews gridtopviewsHistory">
                    <div className="dropdownbox statusdropcontainer branchDropdownBox">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeLogsFilter('entity_type', e) }}
                            options={entityTypeFilterList}
                            selectedValue={entityTypeFilterSelectedValue}
                            name=''
                            isMulti={false}
                            placeholder="Entity Type"
                            isDisabled={false}
                            isClearable={true}
                            closeButton={false}
                            menuHeader="Entity Type"
                            isSearchable={true}
                        />
                    </div>
                    <div className="dropdownbox statusdropcontainer branchDropdownBox">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeLogsFilter('job_type', e) }}
                            options={jobTypeFilterList}
                            selectedValue={jobTypeFilterSelectedValue}
                            name=''
                            isMulti={false}
                            placeholder="Job Type"
                            isDisabled={false}
                            isClearable={true}
                            closeButton={false}
                            menuHeader="Job Type"
                            isSearchable={true}
                        />
                    </div>
                    <div className="dropdownbox statusdropcontainer branchDropdownBox">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeLogsFilter('status', e) }}
                            options={statusFilterList}
                            selectedValue={statusFilterSelectedValue}
                            name=''
                            isMulti={false}
                            placeholder="Status"
                            isDisabled={false}
                            isClearable={true}
                            closeButton={false}
                            menuHeader="Status"
                            isSearchable={true}
                        />
                    </div>
                    <div className='pageinnersearch downloadCsvBtn'>
                        <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{"Download CSV"}</Tooltip>}>
                            <div onClick={() => { logsCsvDownload(); }} className='csvBtnInner'><i className="fa fa-download" aria-hidden="true"></i>
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="pageinnersearch booking">
                        <div className='date-range-picker'>
                            <ErrorBoundary title="CommonDateTimePicker Error">
                                <CommonDateTimePicker
                                    dateRange={true}
                                    selected={logsStartDate}
                                    onChange={onChangeDateRange}
                                    startDate={logsStartDate}
                                    endDate={logsEndDate}
                                    selectsRange={true}
                                    isClearable={true}
                                    placeholderText="Select Date Range"
                                    minDate=""
                                />
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid_content_inner'>
                <div className="ag-theme-alpine aggridview agprises historyGrid modalInnerGrid" style={{ position: 'r' }}>
                    <div className="leadButtonInner onlyDesktop"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                        isAnimating={isAnimating}
                    />
                    </button>
                        <ReactTooltip place="bottom" />
                    </div>
                    <AgGridReact
                        modules={modules}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        components={components}
                        rowSelection="single"
                        rowModelType="infinite"
                        onGridReady={onGridReady}
                        rowHeight={43.9}
                        headerHeight={40.8}
                        cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                        gridOptions={gridOptions}
                        noRowsOverlayComponent={noRowsOverlayComponent}
                        ref={gridRef}
                    />
                </div>
            </div>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={errorLogModalShow}
                    onHide={errorLogModalClose}
                    className="modalcustomize mondimension errorLogDialog"
                    headerShow={true}
                    closeButton={true}
                    footer={false}
                    title="Error Log"
                    body={
                        <div className='error-log-box'>{errorLogModalData && errorLogModalData != "" ? errorLogModalData : ""}
                        </div>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={detailsModalShow}
                    onHide={detailsModalClose}
                    className="modalcustomize mondimension logDetailsDialog"
                    headerShow={true}
                    closeButton={true}
                    footer={false}
                    title="Log Details"
                    body={renderDetailsContent()}
                />
            </ErrorBoundary>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })(withNamespaces()(Logs));
